import React from 'react';
import { ExpiredWarrantyWarningIcon } from 'site-modules/shared/components/inventory/warranty-module/expired-warranty-warning-icon/expired-warranty-warning-icon';

import './warranty-expired-box.scss';

export const WarrantyExpiredBox = () => (
  <div className="warranty-expired-box bg-orange-100 p-0_5 d-flex">
    <ExpiredWarrantyWarningIcon />
    <span className="ms-0_5">The following warranties may be expired. Contact dealer to confirm.</span>
  </div>
);
